import { post, put, patch, remove, get } from '../axios/post'
import axios from 'axios'

export default ({ app }) => {
  app.config.globalProperties.$axios = axios
  app.config.globalProperties.$post = post
  app.config.globalProperties.$put = put
  app.config.globalProperties.$patch = patch
  app.config.globalProperties.$remove = remove
  app.config.globalProperties.$get = get
}
